// Blocklist for UI test shoppers
module.exports = [
  '858780',
  '1170064',
  '1170065',
  '1677921',
  '1491773',
  '1739653',
  '51117',
  '1334146',
  '1334147',
  '1311287',
  '3132089',
  '19879629',
  '145154313',
  '145154335',
  '142901622',
  '114528865',
  '216703797'
];
